import { RECENT_WINDOW_MS } from '../models/healthCheck.constants'

const ISO_HAS_ZONE = /(?:Z|[+-]\d{2}:?\d{2})$/iu

export function parseIsoAssumingUtc(value: string): number {
  const normalized = ISO_HAS_ZONE.test(value) ? value : `${value}Z`
  return Date.parse(normalized)
}

export function isRecent(lastUpdate: string | null, now = Date.now()): boolean {
  if (!lastUpdate) return false
  const timestamp = parseIsoAssumingUtc(lastUpdate)
  if (!Number.isFinite(timestamp)) return false
  const age = now - timestamp
  return age >= 0 && age < RECENT_WINDOW_MS
}
